import { breakpoints } from '@99designs/common/core/settings';
import { SquarespaceDesignerCard_User } from '__generated__/SquarespaceDesignerCard_User';
import Icon from 'launch/components/Icon';
import React from 'react';
import MediaQuery from 'react-responsive';
import CompactMeta from './BriefLayouts/CompactMeta';
import Card from './Card';
import DesignCarousel from './DesignCarousel';

export interface Props {
    topMatch: boolean;
    user: SquarespaceDesignerCard_User;
    isSelected: boolean;
    onMount: () => void;
}

const TopMatch = () => (
    <div className="top-match">
        <span className="top-match__icon">
            <Icon icon="star-2" />
        </span>
        <span>{__('Top Match')}</span>
    </div>
);

class SquarespaceDesignerCard extends React.Component<Props> {
    componentDidMount() {
        this.props.onMount();
    }

    render() {
        const { user, topMatch, isSelected, children } = this.props;
        return (
            <Card variations={isSelected ? ['selected', 'squarespace'] : ['squarespace']}>
                {topMatch && <TopMatch />}
                <Card.Block>
                    <CompactMeta designer={user} />
                </Card.Block>
                <Card.Media>
                    <MediaQuery minWidth={breakpoints.normal[0]}>
                        {matches => <DesignCarousel designer={user} enableOverlay={matches} />}
                    </MediaQuery>
                </Card.Media>
                <Card.Block>{children}</Card.Block>
            </Card>
        );
    }
}
export default SquarespaceDesignerCard;
